import { useState, useEffect } from 'react';

/**
 * Hook for preloading table icons and indicating readiness state
 *
 * This hook manages the preloading of icons used in table components
 * to ensure smooth rendering and prevent layout shifts when icons load.
 *
 * @returns Boolean indicating whether icons have been preloaded
 *
 * @example
 * ```tsx
 * const IconWithPreloader = () => {
 *   const iconsPreloaded = useIconPreloader();
 *
 *   if (!iconsPreloaded) {
 *     return <div>Loading icons...</div>;
 *   }
 *
 *   return (
 *     <div>
 *       <SortIcon />
 *       <FilterIcon />
 *       <ExpandIcon />
 *     </div>
 *   );
 * };
 * ```
 */
export const useIconPreloader = () => {
  const [iconsPreloaded, setIconsPreloaded] = useState(false);

  useEffect(() => {
    setIconsPreloaded(true);
  }, []);

  return iconsPreloaded;
};
